import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/state/auth-context';
import { FiltersProvider } from '@/state/filters-context';
import { AppRoutes } from './routes/router';
import { Toaster } from '@/components/ui/toaster';

/**
 * React Query Client Configuration
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000, // 30 seconds
      gcTime: 300000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

/**
 * App Component
 *
 * Main application entry point with router configuration,
 * authentication context, filters context, and React Query provider.
 *
 * Note: Using BrowserRouter with component-based routing ensures
 * routes are evaluated lazily inside the AuthProvider context,
 * preventing "useAuth must be used within an AuthProvider" errors.
 */
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <FiltersProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
          <Toaster />
        </FiltersProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
